import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import axios from "axios"
import { baseurl } from "../Basurl/Baseurl"
import { isReferralUser, getReferralId } from "../utils/authStorage"
const emptyPatientList = (page = 1, limit = 25) => ({
  details: [],
  pagination: {
    totalRecords: 0,
    currentPage: page,
    totalPages: 0,
    perPage: limit,
  },
});

const normalizePatientListPayload = (payload, page = 1, limit = 25) => {
  if (!payload) return emptyPatientList(page, limit);

  const details =
    payload.details ||
    payload.data?.details ||
    payload.patients ||
    payload.data?.patients ||
    (Array.isArray(payload.data) ? payload.data : null) ||
    (Array.isArray(payload) ? payload : []) ||
    [];

  const pagination =
    payload.pagination ||
    payload.data?.pagination || {
      totalRecords: Array.isArray(details) ? details.length : 0,
      currentPage: page,
      totalPages: Math.max(
        1,
        Math.ceil((Array.isArray(details) ? details.length : 0) / limit) || 0,
      ),
      perPage: limit,
    };

  return { details: Array.isArray(details) ? details : [], pagination };
};

export const GetAllPatients = createAsyncThunk(
  "patient/GetAllPatients",
  async (params = {}, { rejectWithValue }) => {
    try {
      const queryParams = new URLSearchParams();

      queryParams.append("page", params.page || 1);
      queryParams.append("search", params.search || "");
      queryParams.append("limit", params.limit || 25);

      if (params.p_status) queryParams.append("p_status", params.p_status);
      if (params.patient_type_new) queryParams.append("patient_type_new", params.patient_type_new);
      if (params.country) queryParams.append("country", params.country);
      if (params.treatingIn) queryParams.append("treatingIn", params.treatingIn);
      if (params.patient) queryParams.append("patient", params.patient);
      if (params.treatment) {
        queryParams.append("treatment", params.treatment);
        queryParams.append("treatment_course_name", params.treatment);
      }
      if (params.sortField) queryParams.append("sortField", params.sortField);
      if (params.sortOrder) queryParams.append("sortOrder", params.sortOrder);
      if (isReferralUser()) {
        const refId = params.referral_id || getReferralId();
        if (refId) queryParams.append("referral_id", refId);
      }

      const response = await axios.get(
        `${baseurl}all_patients?${queryParams.toString()}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      // ✅ HANDLE 404 HERE
      if (error.response?.status === 404) {
        return emptyPatientList(params.page || 1, params.limit || 25);
      }

      return rejectWithValue(
        error.response?.data || { message: "Failed to fetch patients" }
      );
    }
  }
);

/** GET /api/get_treatment_completed_patients — CRM or Hospital (with hospital_id) */
export const GetTreatmentCompletedPatients = createAsyncThunk(
  "patient/GetTreatmentCompletedPatients",
  async (params = {}, { rejectWithValue }) => {
    const page = params.page || 1;
    const limit = params.limit || 25;
    try {
      const queryParams = new URLSearchParams();
      queryParams.append("page", page);
      queryParams.append("limit", limit);
      if (params.search) queryParams.append("search", params.search);
      if (params.hospital_id != null && params.hospital_id !== "") {
        queryParams.append("hospital_id", params.hospital_id);
      }
      if (params.sortField) queryParams.append("sortField", params.sortField);
      if (params.sortOrder) queryParams.append("sortOrder", params.sortOrder);
      if (isReferralUser()) {
        const referralId = params.referral_id || getReferralId();
        if (referralId) queryParams.append("referral_id", referralId);
      }

      const response = await axios.get(
        `${baseurl}get_treatment_completed_patients?${queryParams.toString()}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      return normalizePatientListPayload(response.data, page, limit);
    } catch (error) {
      if (error.response?.status === 404) {
        return emptyPatientList(page, limit);
      }
      return rejectWithValue(
        error.response?.data || {
          message: "Failed to fetch treatment completed patients",
        }
      );
    }
  }
);



// export const GetAllPatients = createAsyncThunk('patient/GetAllPatients', async () => {
//   try {
//     const response = await axios.get(`${baseurl}all_patients`, {
//       headers: {
//         "Authorization": `Bearer ${localStorage.getItem("token")}`,
//         "Content-Type": "application/json",
//       },
//     });
//     return response.data.details;
//   } catch (error) {
//     console.error("Error fetching patient:", error.response?.data || error.message);
//     throw error; // Rethrow to propagate the error in createAsyncThunk
//   }
// });
export const AddAllPatients = createAsyncThunk(
  "patient/AddAllPatients",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${baseurl}register_patient/${localStorage.getItem("_id")}`, formData, {
        headers: {
          "Authorization": `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
          "Content-Type": "multipart/form-data",
        },
      });
      return response.data; // Success response
    } catch (error) {
      console.error("Error adding staff user:", error.response?.data?.message);
      return rejectWithValue(
        error.response?.data || { message: "An unknown error occurred" }
      );
    }
  })

  
// export const EditPatientType = createAsyncThunk(
//   "patient/EditPatient",
//   async (userData, { rejectWithValue }) => {
//     console.log(userData)
//     try {
//       const response = await axios.put(`${baseurl}update_patient/${userData.id}`, userData.data, {
//         headers: {
//           "Authorization": `Bearer ${localStorage.getItem("token")}`,
//           "Content-Type": "application/json",

//         },
//       });
//       return response.data; // Success response
//     } catch (err) {
//       console.error("Error editing staff user:", err.response?.data?.message);
//       return rejectWithValue(
//         err.response?.data || { message: "An unknown error occurred" }
//       );
//     }
//   }
// );
export const EditPatientType = createAsyncThunk(
  "patient/EditPatient",
  async (payload, { rejectWithValue }) => {
    try {
      if (!payload) {
        throw new Error("Payload is undefined");
      }

      const { id, data } = payload;

      if (!id) {
        throw new Error("Patient ID is missing");
      }

      const response = await axios.put(
        `${baseurl}update_patient/${id}`,
        data,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      return response.data;
    } catch (err) {
      console.error("Edit error:", err);
      return rejectWithValue(
        err.response?.data || { message: err.message }
      );
    }
  }
);

export const DeletePatient = createAsyncThunk('patient/DeletePatient',
  async (patientId, { rejectWithValue }) => {
    try {
      const response = await axios.delete(`${baseurl}deletePatient/${patientId.id}`, {
        headers: {
          "Authorization": `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",

        },
      });
      return patientId; // Success response
    } catch (error) {
      console.error("Error deleting hospital:", error);
      return rejectWithValue(
        error.response?.data || { message: "An unknown error occurred" }
      );
    }
  }
)

export const PainDService = createAsyncThunk(
  "patient/PainDService",
  async (servipostdata, { rejectWithValue }) => {
    console.log(servipostdata, "Service Data")
    try {
      const response = await axios.post(`${baseurl}paid_service}`, {
        headers: {
          "Authorization": `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
          "Content-Type": "multipart/form-data",
        },
      });
      return response.data; // Success response
    } catch (error) {
      console.error("Error adding staff user:", error.response?.data?.message);
      return rejectWithValue(
        error.response?.data || { message: "An unknown error occurred" }
      );
    }
  })

export const StatusPatient = createAsyncThunk(
  "patient/StatusPatient",
  async (object, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");

      if (!token) {
        throw new Error("Authorization token is missing");
      }

      const response = await axios.post(
        `${baseurl}update_patient_status/${object.id}`,
        { status: object.status }, // Ensure you're passing the correct payload
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      return response.data; // Success response
    } catch (err) {
      console.error("Error editing patient status:", err.response?.data?.message);
      return rejectWithValue(
        err.response?.data || { message: "An unknown error occurred" }
      );
    }
  }
);

const patientSlice = createSlice({
  name: 'patient',
  initialState: {
  patient: [],
  pagination: {
    totalRecords: 0,
    currentPage: 1,
    totalPages: 0,
    perPage: 25,
  },
  loading: false,
  error: null,
},
  reducers: {
    addPatient: (state, action) => {
      state.staffUserslice.push(action.payload)
    },

  },
  extraReducers: (builder) => {
    builder
      .addCase(GetAllPatients.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
     .addCase(GetAllPatients.fulfilled, (state, action) => {
        state.loading = false;
        state.patient = action.payload.details;
        state.pagination = action.payload.pagination;
      })
      .addCase(GetAllPatients.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(GetTreatmentCompletedPatients.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(GetTreatmentCompletedPatients.fulfilled, (state, action) => {
        state.loading = false;
        state.patient = action.payload.details;
        state.pagination = action.payload.pagination;
      })
      .addCase(GetTreatmentCompletedPatients.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })


      // Edit a patient user
      .addCase(EditPatientType.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(EditPatientType.fulfilled, (state, action) => {
        state.loading = false;
        const updatedUser = action.payload;

        // Update the staff list with the edited user
        state.patient = state.patient.map((user) =>
          user.patientId === updatedUser.id ? updatedUser : user
        );
      })
      .addCase(EditPatientType.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Delet a Patient data
      .addCase(DeletePatient.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(DeletePatient.fulfilled, (state, action) => {
        state.loading = false;
        const deletedHospitalId = action.payload;
        // Filter out the deleted hospital
        state.patient = state.patient.filter(
          (user) => user.patientId !== deletedHospitalId
        );
      })
      .addCase(DeletePatient.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      //Status Patient
      .addCase(StatusPatient.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(StatusPatient.fulfilled, (state, action) => {
        state.loading = false;
        const updatedUser = action.payload;

        // Update the staff list with the edited user
        state.patient = state.patient.map((user) =>
          user.patientId === updatedUser.id ? updatedUser : user
        );
      })
      .addCase(StatusPatient.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

  }
})
export default patientSlice.reducer
export const { addPatient } = patientSlice.actions